import { FunctionComponent, SVGProps } from 'react'

export const IconSeparatorLogo: FunctionComponent<SVGProps<SVGSVGElement>> = ({
  id,
  ...props
}) => {
  const clip0 = `${id}-clip0`
  return (
    <svg
      width="32"
      height="31"
      viewBox="0 0 32 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath={`url(#${clip0})`}>
        <path
          d="M10.9229 9.37511C12.5264 8.84485 14.2075 8.57085 15.8973 8.55312C15.9232 8.55312 15.9491 8.55312 15.9749 8.55312C16.6129 8.5531 17.2509 8.80934 17.7337 9.30419L21.1392 12.7946C21.5875 13.2541 21.829 13.8374 21.8721 14.4294C21.8289 12.6886 21.5185 10.9742 20.9667 9.33059C20.001 6.46749 18.2939 3.86068 15.923 1.84596C15.6471 1.60737 15.3626 1.37763 15.0608 1.16555L10.1898 1.16571C8.98279 1.16575 7.86204 1.82855 7.25859 2.89783L1.81886 12.5567L1.49989 13.1311C0.896433 14.2004 0.896477 15.5259 1.5 16.5951L1.70693 16.9574C2.18107 16.1267 2.70695 15.3579 3.28455 14.6421C5.33634 12.1324 8.00026 10.3384 10.9229 9.37511Z"
          fill="white"
          fillOpacity="0.6"
          stroke="#374966"
        />
        <path
          d="M10.7974 19.8557C10.2886 18.1944 10.0386 16.4535 10.0471 14.695L10.0471 14.6861C10.0471 14.6243 10.0471 14.5624 10.0471 14.5006L10.0471 14.4917C10.073 13.8731 10.323 13.2722 10.7799 12.8039L14.1852 9.31322C14.6593 8.82718 15.2801 8.57972 15.9008 8.56203C14.2024 8.57092 12.5299 8.85376 10.9263 9.38402C8.00374 10.3473 5.33982 12.1413 3.29665 14.6687C2.71905 15.3845 2.19317 16.1533 1.71903 16.984L7.2801 26.8546C7.88363 27.9238 8.9958 28.5865 10.2114 28.5865L16.936 28.5863C16.617 28.3477 16.3067 28.1091 16.0049 27.8528C13.4874 25.7056 11.7199 22.9132 10.7974 19.8557Z"
          fill="white"
          fillOpacity="0.6"
          stroke="#374966"
        />
        <path
          d="M30.058 12.5286C29.6269 13.2621 29.1441 13.9514 28.6269 14.5965C26.6182 17.0709 24.0146 18.8472 21.1524 19.8282C19.4971 20.3938 17.7642 20.6854 16.0141 20.7032C15.9883 20.7032 15.9624 20.7032 15.9365 20.7032C15.2985 20.7032 14.6606 20.447 14.1778 19.9521L10.7722 16.4617C10.298 15.9757 10.0566 15.3482 10.0394 14.712C10.0308 16.4705 10.2809 18.2114 10.7896 19.8727C11.7122 22.9302 13.4882 25.7314 15.9971 27.861C16.2989 28.1173 16.6092 28.3647 16.9282 28.5944L21.7303 28.5943C22.9373 28.5942 24.058 27.9314 24.6615 26.8622L30.2478 16.947L30.4288 16.6289C31.0323 15.5596 31.0322 14.2341 30.4287 13.1649L30.058 12.5286Z"
          fill="white"
          fillOpacity="0.6"
          stroke="#374966"
        />
        <path
          d="M20.9754 9.34966C21.5272 10.9845 21.8376 12.7076 21.8808 14.4485C21.8894 14.5368 21.8894 14.6252 21.8894 14.7136C21.8722 15.341 21.6222 15.9684 21.1567 16.4545L17.7514 19.9451C17.2772 20.4312 16.6565 20.6786 16.0357 20.6963C17.7859 20.6874 19.5187 20.3869 21.174 19.8213C24.0276 18.8492 26.6398 17.0729 28.6485 14.5896C29.1658 13.9445 29.6485 13.2552 30.0796 12.5218L24.6651 2.90748C24.0616 1.83825 22.9494 1.17552 21.7338 1.17556L15.0781 1.17578C15.3713 1.39669 15.6558 1.62644 15.9403 1.85619C18.3026 3.87975 20.0097 6.48656 20.9754 9.34966Z"
          fill="white"
          fillOpacity="0.6"
          stroke="#374966"
        />
        <path
          d="M21.8828 14.4395C21.8828 14.5278 21.8828 14.6162 21.8918 14.7045C21.8918 14.6162 21.8828 14.5366 21.8828 14.4395Z"
          fill="#374966"
        />
      </g>
      <defs>
        <clipPath id={clip0}>
          <rect
            width="32.001"
            height="30.0011"
            fill="white"
            transform="translate(0 0.0234375)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
